var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cmp cmp-page-title"},[_vm._t("default",function(){return [_c('h2',[_vm._v(_vm._s(_vm.name))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }